import { InternalAxiosRequestConfig } from "axios";

import { User } from "@contexts/Auth";
import { LOCAL_STORAGE } from "@constants";
import { featureFlags } from "@settings";

export const authTokenRequestInterceptor = (
  config: InternalAxiosRequestConfig,
) => {
  const userJSON = localStorage.getItem(LOCAL_STORAGE.USER);
  const mfaEnabled = featureFlags.enableLoginMfaCef;
  const sendIpEnabled = featureFlags.enableSendIp;

  if (userJSON) {
    const { accessToken, corbanId, ip } = JSON.parse(userJSON) as User;

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    if (mfaEnabled && corbanId) {
      config.headers["Id-corban"] = corbanId.toString();
    }

    if (sendIpEnabled && ip) {
      config.headers["Ip"] = ip;
    }
  }

  return config;
};
